import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RelatedServices = ({ relatedServices }) => {
  return (
    <div className="bg-muted/30 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">Related Services</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our comprehensive ICT solutions designed to complement your current requirements
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {relatedServices?.map((service) => (
            <div key={service?.id} className="bg-card border border-border rounded-xl overflow-hidden shadow-subtle hover:shadow-moderate transition-smooth">
              <div className="aspect-video overflow-hidden">
                <Image
                  src={service?.image}
                  alt={service?.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
                    {service?.category}
                  </span>
                  <div className="flex items-center space-x-1">
                    <Icon name="Star" size={14} className="text-warning fill-current" />
                    <span className="text-sm text-muted-foreground">{service?.rating}</span>
                  </div>
                </div>
                
                <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-2">
                  {service?.title}
                </h3>
                
                <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
                  {service?.description}
                </p>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="text-sm text-muted-foreground">
                    <Icon name="Clock" size={14} className="inline mr-1" />
                    {service?.deliveryTime}
                  </div>
                  <div className="text-sm font-medium text-foreground">
                    From {service?.startingPrice}
                  </div>
                </div>
                
                <div className="flex space-x-2">
                  <Link to={`/service-details?id=${service?.id}`} className="flex-1">
                    <Button variant="outline" size="sm" fullWidth>
                      View Details
                    </Button>
                  </Link>
                  <Link to="/rfq-request-form" state={{ serviceId: service?.id, serviceTitle: service?.title }}>
                    <Button variant="default" size="sm" iconName="FileText">
                      Quote
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/product-catalog">
            <Button variant="outline" size="lg" iconName="ArrowRight" iconPosition="right">
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RelatedServices;